import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import Caminho539 from '../../../assets/caminho-539.png';
import Grupo205 from '../../../assets/grupo-205.png';
import {
  BoxImagem,
  Caixa,
  Col,
  Conteudo,
  Imagem,
  Row,
  Secao,
  SecaoBotaoVoltar,
  SecaoCabecalho,
  SecaoTitulo,
  SubTextoBotao,
  BotaoLinkExterno,
  TextoBotao,
  Titulo,
  Tradutor,
  ContainerButtonQueroVisitar,
} from './styles';

const SecaoQueroVisitarOff = ({ iconeCredenciamento, showTitle }) => {
  const { t } = useTranslation();
  const secaoId = t('slugs.queroVisitar');
  const { lang } = useParams();

  const setLanguageAccreditation = (lang) => {
    var defaultUrl =
      'https://sigevent.pro/fenac/visitantes/formularios.php?id_edicao=1729';
    switch (lang) {
      case 'es':
        return `${defaultUrl}&lingua=espanhol&id_visitante=null`;
      // return `${defaultUrl}`;
      case 'en':
        return `${defaultUrl}&lingua=ingles&id_visitante=null`;
      // return `${defaultUrl}`;
      default:
        return `${defaultUrl}`;
    }
  };

  const setLanguageAccommodation = (lang) => {
    var defaultUrl =
      'https://sigevent.pro/merkator/hospedagem/solicitacaowebempresa/index.php?id_edicao=535';
    switch (lang) {
      case 'es':
        return `${defaultUrl}&linguagem=espanhol&id_visitante=null`;
      // return `${defaultUrl}`;
      case 'en':
        return `${defaultUrl}&linguagem=ingles&id_visitante=null`;
      // return `${defaultUrl}`;
      default:
        return `${defaultUrl}&linguagem=portugues`;
    }
  };

  return (
    <Secao id={secaoId} className="mb-4">
      {showTitle && (
        <Fragment>
          <SecaoCabecalho className="mb-4 mb-30">
            <SecaoTitulo>
              <Tradutor path="paginas.inicial.secaoQueroVisitar.titulo" />
            </SecaoTitulo>
            <SecaoBotaoVoltar />
          </SecaoCabecalho>
        </Fragment>
      )}
      <Row>
        <Col md="4">
          <Caixa>
            <Titulo>
              <Tradutor path="paginas.inicial.secaoQueroVisitar.hospedagem.titulo" />
            </Titulo>
            <BoxImagem>
              <Imagem src={Grupo205} />
            </BoxImagem>
            <Conteudo
              dangerouslySetInnerHTML={{
                __html: t(
                  'paginas.inicial.secaoQueroVisitar.hospedagem.conteudo'
                ),
              }}
            ></Conteudo>
            <ContainerButtonQueroVisitar>
              <BotaoLinkExterno
                target="_blank"
                href={setLanguageAccommodation(lang)}
                // href="#quero-visitar"
              >
                <TextoBotao>
                  <Tradutor path="paginas.inicial.secaoQueroVisitar.hospedagem.textoBotao" />
                </TextoBotao>
                <SubTextoBotao>
                  <Tradutor path="paginas.inicial.secaoQueroVisitar.hospedagem.subTextoBotao" />
                </SubTextoBotao>
              </BotaoLinkExterno>
            </ContainerButtonQueroVisitar>
          </Caixa>
        </Col>

        <Col md="4">
          <Caixa>
            <Titulo>
              <Tradutor path="paginas.inicial.secaoQueroVisitar.translado.titulo" />
            </Titulo>
            <BoxImagem>
              <Imagem src={Caminho539} />
            </BoxImagem>
            <Conteudo
              dangerouslySetInnerHTML={{
                __html: t(
                  'paginas.inicial.secaoQueroVisitar.translado.conteudo'
                ),
              }}
            ></Conteudo>
            {/* <ContainerButtonQueroVisitar>
              <BotaoLinkExterno
                // href={`/${lang}/${t('slugs.traslado')}`}
                href="#quero-visitar"
                title="Veja os horário dos traslados para feira e hotéis"
              >
                <TextoBotao>
                  <Tradutor path="paginas.inicial.secaoQueroVisitar.translado.textoEmBreve" />
                </TextoBotao>
              </BotaoLinkExterno>
            </ContainerButtonQueroVisitar> */}
          </Caixa>
        </Col>

        <Col md="4">
          <Caixa>
            <Titulo>
              <Tradutor path="paginas.inicial.secaoQueroVisitar.credenciamento.titulo" />
            </Titulo>
            <BoxImagem>
              <Imagem src={iconeCredenciamento} />
            </BoxImagem>
            <Conteudo
              dangerouslySetInnerHTML={{
                __html: t(
                  'paginas.inicial.secaoQueroVisitar.credenciamento.conteudo'
                ),
              }}
            ></Conteudo>
            <ContainerButtonQueroVisitar>
              <BotaoLinkExterno
                href={setLanguageAccreditation(lang)}
                // href="#quero-visitar"
                title="Faça agora seu credenciamento antecipado"
                target="_blank"
              >
                <TextoBotao>
                  <Tradutor path="paginas.inicial.secaoQueroVisitar.credenciamento.textoBotao" />
                </TextoBotao>
              </BotaoLinkExterno>
            </ContainerButtonQueroVisitar>
          </Caixa>
        </Col>
      </Row>
    </Secao>
  );
};

SecaoQueroVisitarOff.propTypes = {
  iconeCredenciamento: PropTypes.any,
  showTitle: PropTypes.any,
};

export default SecaoQueroVisitarOff;
